module.exports = __webpack_public_path__ + "static/media/tomek.b2d118b5.jpg";